import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({ providedIn: 'root' })
export class HttpUtilityService {
  public apiBaseUrl = environment.apiUrl;
  constructor(private readonly http: HttpClient) {}

  public get<T>(endPoint: string) {
    let path = `${this.apiBaseUrl}/${endPoint}`;
    return this.http.request<T>('GET', path, {
      observe: 'response',
    });
  }

  public getBy<T>(endPoint: string, data: T) {
    let path = `${this.apiBaseUrl}/${endPoint}`;
    return this.http.request('GET', path, {
      body: data,
      observe: 'response',
    });
  }

  public getByParam<T>(endPoint: string, param: any) {
    let path = `${this.apiBaseUrl}/${endPoint}`;
    return this.http.request<T>('GET', path, {
      observe: 'response',
      params: param,
    });
  }

  public getByOptions<T>(endPoint: string, options: any) {
    let path = `${this.apiBaseUrl}/${endPoint}`;
    return this.http.request<T>('GET', path, options);
  }

  public post<T>(
    url: string,
    data?: any,
    responseType: any = 'json'
  ): Observable<HttpResponse<any>> {
    let apiPath = `${this.apiBaseUrl}/${url}`;
    return this.http.request<T>('POST', apiPath, {
      body: data,
      observe: 'response',
      responseType: responseType,
    });
  }

  public put<T>(url: string, data: T) {
    let apiPath = `${this.apiBaseUrl}/${url}`;
    return this.http.request('PUT', apiPath, {
      body: data,
      reportProgress: true,
      observe: 'response',
    });
  }

  public delete<T>(
    url: string,
    ID?: string | number
  ): Observable<HttpResponse<any>> {
    let apiPath = ID
      ? `${this.apiBaseUrl}/${url}/${ID}`
      : `${this.apiBaseUrl}/${url}`;
    return this.http.request<T>('DELETE', apiPath, {
      observe: 'response',
    });
  }
}
